export default __webpack_public_path__ + "static/media/a3.2ee62a54.jpg";